import { useTranslation } from 'react-i18next'
import { apps } from '@/config/apps'
import AppCard from '@/components/portal/AppCard'
import { useAuth } from '@/hooks/useAuth'

export default function HomePage() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const allowedApps = user?.allowedApps ?? []

  const visibleApps = (
    allowedApps.includes('*')
      ? apps
      : apps.filter((app) => allowedApps.includes(app.id))
  ).filter((app) => app.url !== '')

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">{t('home.applications')}</h2>
        <p className="mt-1 text-gray-600">{t('home.description')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {visibleApps.map((app) => (
          <AppCard key={app.id} app={app} />
        ))}
      </div>
    </div>
  )
}
